export default __webpack_public_path__ + "static/media/car.06ce8390.webp";